import React, { FC } from 'react'
import { FlexColumn } from 'src/styled'

interface EmptyCardProps {
  message: string
}

const EmptyCard: FC<EmptyCardProps> = props => {
  return (
    <FlexColumn
      css={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        css={{
          width: 30,
          height: 30,
          borderRadius: 3,
          textAlign: 'center',
          border: 'solid 2px #929090',
          marginBottom: 20,
          fontSize: 35,
          lineHeight: '15px',
          color: '#929090',
        }}
      >
        +
      </div>
      <h4 css={{ color: '#929090' }}>{props.message}</h4>
    </FlexColumn>
  )
}

export default EmptyCard
